import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useAuthStore } from "@/stores/auth";
import { useCompanyStore } from "@/stores/company";

export function useIsHrEnabled() {
  const globalSetting = import.meta.env.VITE_FEATURE_HR_ENABLED;
  const authStore = useAuthStore();
  const companyStore = useCompanyStore();
  const { loginAccount } = storeToRefs(authStore);
  const { selected: selectedCompany } = storeToRefs(companyStore);
  const { hasHrAccess: profileHasHrAccess } = storeToRefs(authStore);

  const isHrEnabled = computed(() => {
    if (globalSetting && globalSetting === "yes") {
      if (loginAccount.value?.role?.canManageHumanResources === true) {
        return true;
      }

      // Check for company-level HR access
      if (selectedCompany.value?.hrEnabled === true) {
        return true;
      }
    }
    return false;
  });

  const hrEnabledAndAccessAllowed = computed(() => {
    return isHrEnabled.value; // && profileHasHrAccess.value;
  });

  return { isHrEnabled, hrEnabledAndAccessAllowed };
}
